import { http } from "@/utils/http";
import { AxiosResponse } from "axios";
import {
  IInspectionFilter,
  IInspection,
  IInspectionItem,
  IManualInspection,
} from "@/features/inspections/inspection.types";
import { cleanParams } from "@/utils/cleanParams";

export const inspectionService = {
  getInspections(filter?: IInspectionFilter): Promise<AxiosResponse> {
    return http.get<IInspection>("/inspections", {
      params: cleanParams(filter),
    });
  },

  uploadReport(inspectionId: string, report: File): Promise<AxiosResponse> {
    const formData = new FormData();
    formData.append("report", report);
    return http.post(`/inspections/${inspectionId}/report`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  downloadReport(inspectionId: string): Promise<AxiosResponse> {
    return http.get<IInspectionItem>(`/inspections/${inspectionId}/report`, {
      responseType: "blob",
    });
  },

  deleteReport(inspectionId: string): Promise<AxiosResponse> {
    return http.delete(`/inspections/${inspectionId}/report`, {});
  },

  updateComment(inspectionId: string, payload: any): Promise<AxiosResponse> {
    return http.put(`/inspections/${inspectionId}/comment`, payload);
  },

  createManualInspection(payload: IManualInspection): Promise<AxiosResponse> {
    return http.post("/inspections/manual", payload);
  },
};
